import { render, staticRenderFns } from "./PageReports.vue?vue&type=template&id=21bbd20e&"
import script from "./PageReports.vue?vue&type=script&lang=js&"
export * from "./PageReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports